// COPIED from Remote-Leverage/hriq@3b50a234afdd packages/design-system/lib/portal-stack-context.tsx by apps/web/scripts/sync-design-system.mjs. Do not edit: change it in Hriq and re-sync.
// @ts-nocheck -- type-checked in Hriq under its own compiler options (the CRM's are stricter).
"use client";

import { createContext, useContext, type ReactNode } from "react";

/** Stacking tier for portaled pickers/menus relative to full-screen system overlays. */
export type PortalStackTier = "default" | "systemAlert";

const PortalStackContext = createContext<PortalStackTier>("default");

export function PortalStackProvider({
  tier,
  children,
}: {
  tier: PortalStackTier;
  children: ReactNode;
}) {
  return (
    <PortalStackContext.Provider value={tier}>
      {children}
    </PortalStackContext.Provider>
  );
}

export function usePortalStackTier(): PortalStackTier {
  return useContext(PortalStackContext);
}
